// import React, { useState } from "react";
import {
  IMemberListData,
  // IVideoData,
  IVideoFilesData,
} from "../../exports/interfaces";
// import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import DynamicToolTip from "../DynamicToolTip";
import { useLoader } from "../../context/LoaderContext";
import { Fade } from "react-awesome-reveal";
import { useUserDataContext } from "../../context/UserDataContext";
import { formatFromDateDetails } from "../../exports/functions";
import useMobile from "../../hooks/useMobile";
import { Link } from "react-router-dom";
import { scroller } from "react-scroll";

const ArchiveVideos = (props: {
  archiveVideoData: IVideoFilesData[];
  matchedMember: IMemberListData | undefined;
}) => {
  const { loading } = useLoader();
  const isMobile = useMobile();
  // const groupedData = props.archiveVideoData.reduce((acc, item) => {
  //   const doctor = item.attributes.Doctor_Name;

  //   const existingDoctor = acc.find((name) => name.doctor === doctor);

  //   if (existingDoctor) {
  //     existingDoctor.data.push(item);
  //   } else {
  //     acc.push({ doctor, data: [item] });
  //   }

  //   return acc;
  // }, [] as { doctor: string; data: typeof props.archiveVideoData }[]);
  // const [open, setOpen] = useState(false);
  // const [videoUrl, setVideoUrl] = useState<string | null>(null);
  // const handleVideoClick = (url: string) => {
  //   setVideoUrl(url);
  //   setOpen(true);
  // };

  // const handleClose = () => {
  //   setOpen(false);
  //   setVideoUrl(null);
  // };
  const { userData } = useUserDataContext();
  const archiveVideos = userData?.data?.roles?.some(
    (r: { name: string }) => r?.name === "sa",
  )
    ? props.archiveVideoData
    : props?.matchedMember?.attributes?.Type_Of_Membership?.toLowerCase()?.replace(
          /\s/g,
          "",
        ) === "associatemembership" &&
        props?.matchedMember?.attributes?.Status === "Active"
      ? props.archiveVideoData?.filter(
          (video) => video?.view_to_all || video?.associate_membership,
        )
      : props?.matchedMember?.attributes?.Type_Of_Membership?.toLowerCase()?.replace(
            /\s/g,
            "",
          ) === "one-timemembership" &&
          props?.matchedMember?.attributes?.Status === "Active"
        ? props.archiveVideoData?.filter(
            (video) => video?.view_to_all || video?.one_time_membership,
          )
        : props?.matchedMember?.attributes?.Type_Of_Membership?.toLowerCase()?.replace(
              /\s/g,
              "",
            ) === "corporatemembership" &&
            props?.matchedMember?.attributes?.Status === "Active"
          ? props.archiveVideoData?.filter(
              (video) => video?.view_to_all || video?.corporate_membership,
            )
          : props?.archiveVideoData
              ?.filter((video) => video?.view_to_all)
              ?.map((video) => ({
                ...video,
                attributes: {
                  ...video,
                  ...formatFromDateDetails(video?.date),
                },
              }));

  const linkClicker = (path: string) => {
    const pathLocation = window.location.pathname.includes(path);
    if (!pathLocation) {
      window.scrollTo(0, 0);
    } else {
      scroller.scrollTo("toTop", {
        duration: 500,
        smooth: true,
      });
    }
  };

  return (
    <>
      {/* <section className="volunteers-one" style={{ padding: "90px 0 90px" }}>
        <div className="container">
          <div className="section-title text-center">
              <h2 className="section-title__title">{group.doctor}</h2>
              </div>
          <div className="row">
            {props.archiveVideoData?.map((group) => (
              <div className="col-xl-3 col-lg-4 col-md-6" key={group.id}>
                <div className="tab-content__inner-right ">
                  <div className="tab-content__video-link">
                    <div
                      className="tab-content-video-bg"
                      style={{
                        backgroundImage: `url(${process.env.REACT_APP_strapiUrl}${group?.attributes?.Thumbnail?.data?.attributes?.url})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    ></div>
                    <div
                      onClick={() =>
                        handleVideoClick(
                          `${process.env.REACT_APP_strapiUrl}${group?.attributes?.Video?.data?.attributes?.url}`
                        )
                      }
                      className="video-popup"
                      style={{ cursor: "pointer" }}
                    >
                      <div className="tab-content__video-icon">
                        <span className="fa fa-play"></span>
                        <i className="ripple"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
      {/* <section className="events-page custom-padding">
        <div className="container">
          <div className="row">
            {!loading &&
              props.archiveVideoData?.map((group, index) => (
                <div className="col-5th custom-margin-bottom" key={group.id}>
                  <Fade
                    key={index}
                    cascade
                    damping={0.2}
                    triggerOnce={true}
                    delay={index * 200}
                  >
                    <div className="events__single">
                      <div className="custom-vid-div row-image">
                        <div
                          className="tab-content-video-bg"
                          style={{
                            backgroundImage: `url(${process.env.REACT_APP_strapiUrl}${group?.attributes?.Thumbnail?.data?.attributes?.url})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        ></div>
                        <DynamicToolTip title="Play Video">
                          <div
                            onClick={() =>
                              handleVideoClick(group?.attributes?.Video_Link)
                            }
                            className="video-popup"
                            style={{ cursor: "pointer" }}
                          >
                            <div className="tab-content__video-icon">
                              <span className="fa fa-play"></span>
                              <i className="ripple"></i>
                            </div>
                          </div>
                        </DynamicToolTip>
                      </div>
                      <div className="events__content row-content">
                        <h3
                          className="events__title custom-grid-font-size text-truncate"
                          style={{ marginBottom: "unset" }}
                        >
                          <DynamicToolTip
                            title={group?.attributes?.Video_Title}
                          >
                            {group?.attributes?.Video_Title}
                          </DynamicToolTip>
                        </h3>
                        <p
                          className="text-truncate"
                          style={{ marginBottom: "unset" }}
                        >
                          <DynamicToolTip
                            title={group?.attributes?.Doctor_Name}
                          >
                            {group?.attributes?.Doctor_Name}
                          </DynamicToolTip>
                        </p>
                      </div>
                    </div>
                  </Fade>
                </div>
              ))}
          </div>
        </div>
      </section>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            background: "transparent",
            boxShadow: "none",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "8px 0px 8px 8px",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              color: "#fff",
              padding: "0px",
            }}
          >
            <i className="icon-cross" style={{ fontSize: "14px" }}></i>
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ padding: "0px" }}>
          {videoUrl && (
            <iframe
              width="100%"
              height="460dvh"
              src={videoUrl.replace("watch?v=", "embed/").split("&")[0]}
              title="YouTube video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                border: "none",
              }}
            ></iframe>
          )}
        </DialogContent>
      </Dialog> */}
      <section
        className={`events-page ${!userData?.data?.id ? "" : "custom-padding"}`}
      >
        <div className="container">
          {!userData?.data?.id ? (
            <div
              className="become-volunteer__btn-box"
              style={{ marginTop: "40px" }}
            >
              <p>Become a Member to Download Consent Form</p>
              <Link
                to="/become-a-member"
                // className="donate-btn main-header-two__btn"
                className="thm-btn main-header-two__btn custom-donate-btn"
                style={{ paddingLeft: "5px" }}
                onClick={() => linkClicker("become-a-member")}
              >
                {" "}
                <i className="icon-user-plus"></i>
                Become a Member
              </Link>
            </div>
          ) : (
            <div className="row" style={{ justifyContent: "center" }}>
              {!loading &&
                archiveVideos?.map((video, index) => (
                  <div
                    className="col-5th custom-margin-bottom"
                    key={video.id}
                    style={{ width: "50%" }}
                  >
                    <Fade
                      key={index}
                      cascade
                      damping={0.2}
                      triggerOnce={true}
                      delay={index * 200}
                    >
                      <div className="events__single">
                        {/* <div className="events__img">
                          <img
                            src={
                              video?.thumbnail[0]?.media?.url &&
                              `${process.env.REACT_APP_cmsUrl}${video?.thumbnail[0]?.media?.url}`
                            }
                            alt="newsletter-image"
                            className="row-image"
                            style={{
                              objectFit: "contain",
                            }}
                          />

                          {video?.date && (
                            <div className="events__date">
                              <p>
                                {video?.from_date} <br />
                                {video?.from_month} <br />
                                {video?.from_year}
                              </p>
                            </div>
                          )}
                        </div> */}
                        <div
                          className="events__content row-content"
                          style={{
                            borderRadius: "8px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "15px 20px",
                            flexWrap: isMobile ? "wrap" : "nowrap",
                          }}
                        >
                          <h3
                            className="events__title text-truncate custom-grid-font-size"
                            style={{ marginBottom: "5px" }}
                          >
                            {/* <Link
                        to="/events/events-details"
                        state={{
                          id: event.id,
                          bannerUrl: props?.eventBannerImage
                        }}
                      > */}
                            <DynamicToolTip title={video?.file_title}>
                              {video?.file_title}
                            </DynamicToolTip>
                            {/* </Link> */}
                          </h3>
                          {/* <ul className="list-unstyled events__meta"> */}
                          {/* <li>
                        <i className="far fa-clock"></i>
                        {event?.attributes?.Time}
                      </li>
                      <li>
                        <i className="fas fa-map-marker-alt"></i>
                        {event?.attributes?.Event_Location}
                      </li> */}
                          <div
                            className={`custom-newsletter-button ${isMobile ? "w-100" : ""}`}
                          >
                            <a
                              href={`${process.env.REACT_APP_cmsUrl}${video?.file[0]?.media?.url}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="thm-btn main-header-two__btn custom-main-header-two__btn custom-donate-btn"
                            >
                              {/* <i className="fa fa-heart"></i>  */}
                              Download
                            </a>
                          </div>
                          {/* </ul> */}
                        </div>
                      </div>
                    </Fade>
                  </div>
                ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default ArchiveVideos;
